// @flow

import React from 'react'
import { connect } from 'react-redux'
import bindAll from 'lodash/bindAll'

import {
	Field,
	reduxForm
} from 'redux-form'

import RenderInput from './RenderInput'

import validateForUserRegisterWizardForm from './validateForUserRegisterWizardForm'

import { usersValidateEmailOnUserRegisterWizardFormRequest } from '../../../actions/users'

type Props = {
	pristine: boolean,
	submitting: boolean,
	handleSubmit: Function,
	asyncValidating: boolean,
	usersValidateEmailOnUserRegisterWizardFormRequest: Function
};

const normalizeEmail = (value, previousValue) => {
	return value.trim()
}

class UserRegisterWizardFormFirstPage extends React.Component<Props> {
	constructor(props) {
		super(props)

		bindAll(this, [
			'handleEmailChange'
		])
	}

	handleEmailChange(e) {
		this.props.usersValidateEmailOnUserRegisterWizardFormRequest(e.target.value.trim())
	}

  render() {
  	const {
  		pristine,
  		submitting,
  		handleSubmit,
  		asyncValidating
  	} = this.props

    return(
    	<form onSubmit={handleSubmit}>
    		<div className="well-form rounded-sm" id="step1">
    			<h3 className="heading3 semibold m-0 m-b-40">CREATE YOUR FREE ACCOUNT</h3>
    			<Field
    				component={RenderInput}
    				name="email"
    				onChange={this.handleEmailChange}
    				props={{
    					isValidatingEmail: asyncValidating
    				}}
    				label="Email"
					normalize={normalizeEmail} />
    			<Field
    				component={RenderInput}
    				name="fullname"
    				label="Full Name" />
    			<Field
    				component={RenderInput}
    				name="password"
    				type="password"
    				label="Password" />
    			<Field
    				component={RenderInput}
    				name="company_name"
    				label="Company Name" />
    			<div className="center m-t-32">
    				<button
    					disabled={submitting || pristine || asyncValidating}
    					className="btn btn-primary"
    					type="submit">Next</button>
    			</div>
    		</div>
    	</form>
    )
  }
}

UserRegisterWizardFormFirstPage = reduxForm({
  form: 'UserRegisterWizardForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateForUserRegisterWizardForm
})(UserRegisterWizardFormFirstPage)

const mapDispatchToProps = (dispatch) => {
	return {
		usersValidateEmailOnUserRegisterWizardFormRequest: (email) => dispatch(usersValidateEmailOnUserRegisterWizardFormRequest(email)),
	}
}

export default connect(null, mapDispatchToProps)(UserRegisterWizardFormFirstPage)
